export class TableActions {
  constructor(private actions: any) {}

  renderItem() {
    return this.actions;
  }
}
